module.exports = "/virtual-football-league/img/jerseys/Blue.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/jerseys/Blue.png
// module id = 2239
// module chunks = 4